import React, { useState, useContext, useEffect, useRef } from "react";
import { Page, Spinner, Icon } from "components";
import classNames from "lib/classNames";
import ShopContext from "context/ShopContext";
import UserContext from "context/UserContext";
import { API_GATEWAY_NEW, APP_DEV } from "aws-exports";
import { API } from "aws-amplify";
import moment from "moment";
import { SAVE_PLAN_SETTINGS } from "lib/mutations";
import { useMutation } from "@apollo/react-hooks";
import { GET_SHOP_SETTINGS } from "Queries";
import { Loading, Toast } from "@shopify/app-bridge-react";
import useRefState from "hooks/useRefState";
import getPlans, { getBasePrice } from "lib/getPlans";

// ⛔⛔ do not remove
// this classes for the css purge
// border-teal-500
// border-blue-500
// border-indigo-500
// border-purple-500
// bg-teal-500
// bg-blue-500
// bg-indigo-500
// bg-purple-500
// text-teal-500
// text-blue-500
// text-indigo-500
// text-purple-500

const PlanScreen = () => {
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const user = useContext(UserContext);
  const { state: shop } = useContext(ShopContext);
  const plans = getPlans(new Date(shop.installedAt).getTime());
  const hasDiscount =
    shop?.invitation &&
    shop?.invitation?.type === "discount_percentage" &&
    shop?.invitation?.value;
  const discount = hasDiscount ? shop.invitation.value / 100 : 0;
  const applyDiscount = (value) =>
    Number((value - value * discount).toFixed(2));
  const getPlan = async () => {
    const planResponse = await API.get("API_GATEWAY_NEW", "/shop/get_plan");
    const { balance_used } = planResponse;
    setCurrentPlan(
      balance_used === 0
        ? 0
        : plans.findIndex(
          ({ real_price }) =>
            applyDiscount(real_price).toString() ===
            (balance_used + applyDiscount(getBasePrice())).toFixed(2)
        )
    );
    setPlan(planResponse);
    setLoading(false);
  };

  useEffect(() => {
    getPlan();
  }, []);

  return (
    <Page background="white" header={{ title: "Your Plan" }}>
      {loading && (
        <>
          <Spinner />
          <Loading />
        </>
      )}
      {!loading && plan && (
        <>
          <div className={classNames("mb-4 rounded bg-white mx-auto w-1/2")}>
            <div
              className={classNames(
                "flex items-start  border-b p-3 font-bold text-sm"
              )}
            >
              <label className={classNames("flex-1 capitalize text-gray-600")}>
                Current Plan
              </label>
              <div className={classNames("w-40 text-gray-700")}>
                <p>{plans[currentPlan]?.description}</p>
              </div>
            </div>
            <div
              className={classNames(
                "flex items-start  border-b p-3 font-bold text-sm"
              )}
            >
              <label className={classNames("flex-1 capitalize text-gray-600")}>
                Amount To Be Charged
              </label>
              <div className={classNames("w-40 text-gray-700")}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: `$${(
                      plan.balance_used + applyDiscount(getBasePrice())
                    ).toFixed(2)}${
                      // plan.balance_used > 0
                      // 	? ` <span class='mu-text-xs mu-text-gray-500'>(${plans[currentPlan].description})</span>`
                      // 	: ''
                      ""
                      }`
                  }}
                />
              </div>
            </div>
            <div
              className={classNames(
                "flex items-center  border-b p-3 font-bold text-sm"
              )}
            >
              <label className={classNames("flex-1 capitalize text-gray-600")}>
                Status
              </label>
              <div className={classNames("w-40 text-gray-700")}>
                <p>{plan.status}</p>
              </div>
            </div>
            <div
              className={classNames(
                "flex items-center  border-b p-3 font-bold text-sm"
              )}
            >
              <label className={classNames("flex-1 capitalize text-gray-600")}>
                Billing Date
              </label>
              <div className={classNames("w-40 text-gray-700")}>
                <p>
                  {plan.billing_on
                    ? moment(plan.billing_on).format("MMM Do YYYY")
                    : "Not Set"}
                </p>
              </div>
            </div>
            <div
              className={classNames(
                "flex items-center   p-3 font-bold text-sm"
              )}
            >
              <label className={classNames("flex-1 capitalize text-gray-600")}>
                Transactions This Month
              </label>
              <div className={classNames("w-40 text-gray-700")}>
                <p>{shop.transactions}</p>
              </div>
            </div>
          </div>
          <div className={classNames("flex-center p-3 mx-auto w-1/2")}>
            <a
              className={classNames(
                "font-bold text-sm text-blue-500 hover:underline"
              )}
              href="https://monsterapps.crisp.help/en/article/pricing-and-billing-charges-48yd1o/"
              target="_blank"
            >
              Visit our pricing page for more information
            </a>
          </div>
        </>
      )}
    </Page>
  );
};

export default PlanScreen;